export enum WithdrawalStatus {
  PENDING = 'pending',
  REVIEWING = 'reviewing',
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
  REJECTED = 'rejected',
}

export type WithdrawalReviewStatus =
  | WithdrawalStatus.REVIEWING
  | WithdrawalStatus.CONFIRMED
  | WithdrawalStatus.REJECTED;

export interface WithdrawalModel {
  id: number;
  userId: number;
  reviewedBy: number | null;
  status: WithdrawalStatus;
  address: string;
  requestedAmount: string;
  fee: string;
  payoutAmount: string;
}

export type WithdrawalHistoryResponse = {
  id: number;
  status: WithdrawalStatus;
  address: string;
  requestedAmount: string;
  fee: string;
  payoutAmount: string;
  createdAt: string;
}[];

export interface CreateWithdrawalPayload {
  address: string;
  requestedAmount: string;
}

export interface CancelWithdrawalPayload {
  withdrawalId: number;
}

export enum WithdrawalTagType {
  WITHDRAWAL = 'Withdrawal',
}
